"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormPage = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
const lib_1 = require("./lib");
function FormPage({ successPage, scrollInto, scrollIntoOptions, className, children, }) {
    var _a;
    const pageId = (0, app_1.useCuid)();
    const ref = (0, react_1.useRef)(null);
    const dispatch = (0, react_1.useContext)(lib_1.InternalFormDispatchContext);
    const { activePage } = (_a = (0, react_1.useContext)(lib_1.InternalFormContext)) !== null && _a !== void 0 ? _a : {};
    const [fatal, setFatal] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (fatal) {
            console.error(`FATAL: ${fatal}`);
        }
    }, [fatal]);
    (0, react_1.useEffect)(() => {
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && activePage && (scrollInto || scrollIntoOptions)) {
            (0, utils_1.scrollIntoView)(ref === null || ref === void 0 ? void 0 : ref.current, scrollIntoOptions);
        }
    }, [ref, activePage, scrollIntoOptions, scrollInto]);
    const isNestedPage = Boolean((0, react_1.useContext)(lib_1.FormPageContext));
    (0, react_1.useEffect)(() => {
        if (isNestedPage) {
            setFatal("<FormPage> component can't be nested inside another <FormPage>");
        }
    }, [isNestedPage]);
    (0, react_1.useEffect)(() => {
        if (dispatch) {
            dispatch('REGISTER_PAGE', { pageId, options: { successPage } });
            return () => dispatch('UNREGISTER_PAGE', pageId);
        }
        setFatal('FormPage has to be contained by a <Form> component');
    }, [dispatch, successPage, pageId]);
    if (fatal) {
        return (0, jsx_runtime_1.jsxs)("div", { children: ["FATAL: ", fatal] });
    }
    return activePage === pageId ? ((0, jsx_runtime_1.jsx)(lib_1.FormPageContext.Provider, Object.assign({ value: pageId }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: className, ref: ref }, { children: children })) }))) : null;
}
exports.FormPage = FormPage;
